module.exports = __webpack_public_path__ + "static/media/vmware.6226e22f.png";